import React from "react";

import barcode1 from "./../assets/barcode1.webp";
import barcode2 from "./../assets/barcode2.webp";

const AccountDetails = ({ donateLink }) => {
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      alert("Copied to clipboard!");
    });
  };

  return (
    <div className="w-full py-4 md:py-8 px-2.5 md:px-5 bg-transparent">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 max-w-7xl mx-auto">
        {/* Box 1: Bank Transfer */}
        <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200">
          <div className="text-center mb-3 pb-3 border-b border-gray-100">
            <h3 className="text-xl font-semibold text-red m-0">
              Donation Through Bank (NEFT/RTGS)
            </h3>
          </div>
          <div className="flex flex-col gap-2">
            {[
              { label: "Bank Name", value: "HDFC Bank" },
              { label: "Account Name", value: "ISKCON" },
              { label: "Account Number", value: "50100436709020" },
              { label: "IFSC Code", value: "HDFC0000568" },
              { label: "Branch", value: "ONE TOWN VIJAYAWADA" },
            ].map(({ label, value }, i, arr) => (
              <div
                key={label}
                className={`flex justify-between items-center py-2.5 ${i < arr.length - 1 ? "border-b border-gray-100" : ""}`}
              >
                <div className="flex flex-col gap-0.5 flex-1 min-w-0 pr-2">
                  <span className="text-sm text-gray-500 font-medium">
                    {label}:
                  </span>
                  <span className="text-sm sm:text-base text-red font-semibold font-mono break-all">
                    {value}
                  </span>
                </div>
                <button
                  className="bg-red text-white border-none px-3 py-1.5 rounded text-xs sm:text-sm font-medium cursor-pointer transition-all hover:bg-darkred whitespace-nowrap shrink-0"
                  onClick={() => copyToClipboard(value)}
                >
                  Copy
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Box 2: QR Code 1 */}
        <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200">
          <div className="text-center mb-3 pb-3 border-b border-gray-100">
            <h3 className="text-xl font-semibold text-red m-0">
              Donate using QR Code
            </h3>
          </div>
          <div className="flex flex-col items-center gap-4 mt-4 sm:mt-6">
            <div className="w-44 h-44 bg-gray-50 rounded-lg flex items-center justify-center overflow-hidden border border-gray-200">
              <img
                src={barcode1}
                alt="QR Code for Donation"
                className="w-full h-full object-contain"
              />
            </div>
            <div className="text-center flex flex-col gap-3 w-full">
              <p className="text-lg text-red font-semibold m-0">
                ISKCON Vijayawada
              </p>
              <button
                className="bg-red text-white border-none py-3 px-8 rounded-full text-base font-semibold cursor-pointer transition-all hover:bg-darkred w-full max-w-[200px] mx-auto"
                onClick={() =>
                  window.open(donateLink || "https://rzp.io/rzp/H3NMKYC")
                }
              >
                Donate now
              </button>
            </div>
          </div>
        </div>

        {/* Box 3: QR Code 2 with UPI */}
        <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200 sm:col-span-2 lg:col-span-1">
          <div className="text-center mb-3 pb-3 border-b border-gray-100">
            <h3 className="text-xl font-semibold text-red m-0">
              Donate Through UPI
            </h3>
          </div>

          <div className="text-center text-sm text-gray-600 leading-relaxed py-2 px-2 bg-gray-50 rounded-md w-full mb-4">
            Scan the QR code to donate instantly
          </div>

          <div className="flex flex-col items-center gap-4">
            <div className="w-44 h-44 bg-gray-50 rounded-lg flex items-center justify-center overflow-hidden border border-gray-200">
              <img
                src={barcode2}
                alt="UPI QR Code"
                className="w-full h-full object-contain"
              />
            </div>
            <div className="text-center relative my-2 w-full">
              <span className="bg-white px-3 text-gray-600 text-sm font-medium relative z-10">
                OR
              </span>
              <div className="absolute top-1/2 left-0 w-[45%] h-px bg-gray-200"></div>
              <div className="absolute top-1/2 right-0 w-[45%] h-px bg-gray-200"></div>
            </div>
            <div className="flex flex-col gap-2 w-full">
              <span className="text-base text-gray-600 font-medium text-center">
                UPI ID:
              </span>
              <div className="flex items-center justify-between bg-gray-50 py-2.5 px-3 rounded-md border border-gray-200">
                <p className="text-xs sm:text-sm text-red font-semibold font-mono break-all m-0">
                  ISCKONVIJAYAWADA@IDFCBANK
                </p>
                <button
                  className="bg-red text-white border-none px-4 py-2 rounded text-sm font-medium cursor-pointer transition-all hover:bg-darkred ml-2 whitespace-nowrap"
                  onClick={() => copyToClipboard("ISCKONVIJAYAWADA@IDFCBANK")}
                >
                  Copy
                </button>
              </div>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountDetails;
